'use strict';

var _classCallCheck = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/circleci/repo/projects/idea-hub-client/node_modules/@babel/runtime/helpers/inherits");

var setImmediate = require('async/setImmediate');

var EE = require('events').EventEmitter;

var Connection = require('interface-connection').Connection;

var utilsFactory = require('./utils');

var PeerInfo = require('peer-info');

var proto = require('../protocol').CircuitRelay;

var series = require('async/series');

var debug = require('debug');

var log = debug('libp2p:circuit:stop');
log.err = debug('libp2p:circuit:error:stop');

var Stop =
/*#__PURE__*/
function (_EE) {
  _inherits(Stop, _EE);

  function Stop(swarm) {
    var _this;

    _classCallCheck(this, Stop);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Stop).call(this));
    _this.swarm = swarm;
    _this.utils = utilsFactory(swarm);
    return _this;
  }
  /**
   * Handle the incoming STOP message
   *
   * @param {{}} msg  - the parsed protobuf message
   * @param {StreamHandler} sh  - the stream handler wrapped connection
   * @param {Function} callback  - callback
   * @returns {undefined}
   */


  _createClass(Stop, [{
    key: "handle",
    value: function handle(msg, sh, callback) {
      var _this2 = this;

      callback = callback || function () {};

      series([function (cb) {
        return _this2.utils.validateAddrs(msg, sh, proto.Type.STOP, cb);
      }, function (cb) {
        return _this2.utils.writeResponse(sh, proto.Status.Success, cb);
      }], function (err) {
        if (err) {
          // we don't return the error here,
          // since multistream select don't expect one
          callback();
          return log(err);
        }

        var peerInfo = new PeerInfo(_this2.utils.peerIdFromId(msg.srcPeer.id));
        msg.srcPeer.addrs.forEach(function (addr) {
          return peerInfo.multiaddrs.add(addr);
        });
        var newConn = new Connection(sh.rest());
        newConn.setPeerInfo(peerInfo);
        setImmediate(function () {
          return _this2.emit('connection', newConn);
        });
        callback(newConn);
      });
    }
  }]);

  return Stop;
}(EE);

module.exports = Stop;